module.exports = __webpack_public_path__ + "img/arrow-mini.0ab422d8.svg";